import { Component } from '@angular/core';
import {  NavController, NavParams, LoadingController, MenuController } from 'ionic-angular';
import { Consultas } from '../../providers/consultas';
import { VariablesGlobales } from '../../providers/variables-globales';
import { BuscadorPage } from '../buscador/buscador';
import { OfertaYNoticia } from '../../models/ofertaynoticia.model';
import { NoticiaPage } from '../noticia/noticia';

/**
 * Generated class for the NoticiasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-noticias-generales',
  templateUrl: 'noticias-generales.html',
})
export class NoticiasGeneralesPage {

  public noticias: Array<OfertaYNoticia>;
  public loader: any;
  public idCategoria: number;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global: VariablesGlobales,public menuCtrl:MenuController) {
      this.idCategoria = navParams.get("idCategoria");
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad NoticiasGenerales');
  }
  ngOnInit(){
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
        this.consultas.getNoticiasGenerales(this.idCategoria).subscribe(x=>
          {
            this.noticias = x;
            this.loader.dismiss();
          },error=>console.error()
          );
    });
  }
  goToNoticia(noticia){
    this.navCtrl.push(NoticiaPage,{noticia});
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/noticias-generales/noticias-generales.ts